"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _icon = _interopRequireDefault(require("@mapbox/mr-ui/icon"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var CodeSnippetTitle = /*#__PURE__*/function (_React$Component) {
  _inherits(CodeSnippetTitle, _React$Component);

  var _super = _createSuper(CodeSnippetTitle);

  function CodeSnippetTitle() {
    var _this;

    _classCallCheck(this, CodeSnippetTitle);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "renderFilename", function () {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "inline-block txt-bold mb6 color-gray-dark"
      }, _this.props.filename);
    });

    _defineProperty(_assertThisInitialized(_this), "renderLink", function () {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "inline-block ml12-mm"
      }, /*#__PURE__*/_react.default.createElement("a", {
        className: "unprose link",
        href: _this.props.link,
        title: "View ".concat(_this.props.filename, " on GitHub")
      }, /*#__PURE__*/_react.default.createElement(_icon.default, {
        name: "github",
        inline: true
      }), " View on GitHub"));
    });

    return _this;
  }

  _createClass(CodeSnippetTitle, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          link = _this$props.link,
          toggle = _this$props.toggle;
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "flex-parent-mm flex-parent--space-between-main-mm mb6"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "flex-child"
      }, this.renderFilename(), link && this.renderLink()), toggle && /*#__PURE__*/_react.default.createElement("div", {
        className: "flex-child"
      }, toggle));
    }
  }]);

  return CodeSnippetTitle;
}(_react.default.Component);

exports.default = CodeSnippetTitle;
CodeSnippetTitle.propTypes = {
  /* Filename to be displayed as a kind of title. Can be a specific filename like
  `RuntimeStylingActivity.java` or a general filename like `Activity`. */
  filename: _propTypes.default.string,

  /* Optional `link` to a GitHub file. If this is set, the rendered component
  will include a "View on Github" link. */
  link: function link(props, propName, componentName) {
    if (props[propName] && !/^https:\/\/github\.com\//.test(props[propName])) {
      return new Error('Invalid prop `' + propName + '` supplied to' + ' `' + componentName + '`. Validation failed.');
    }
  },

  /* Language toggle to be displayed. */
  toggle: _propTypes.default.node
};